import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { MisdeliveryNotesData, MdsNoteResponse } from "../models";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

/**
 * CREATE API call using Axios
 * @returns - Create ON Hand and return same object
 */

export const CreateMSDNotes = async (params: MisdeliveryNotesData): Promise<MdsNoteResponse> => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.MSD_NOTES) || {};
    // Add dynamic OSD-Exception-Number
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": params.exceptionNumber,
    };
    const response = await axios.post(getUrl(ApiType.MSD_NOTES), params, { headers });
    return response.data;
  } catch (error: unknown) {
    return throwApiError(error, ErrorMessages.createMSDNotes, { badRequestOrder: "errorsFirst" });
  }
};
